import React from 'react';
import { observer } from 'mobx-react';
import { TafFileDropZone } from '@taf-ui/react';

import AppStorage from '../Storage/Storage';
import { isBrand } from '../utils/utils';
import Brand from '../enums/Brand';

interface FileInputProps {
  fileUploadHandler(fileList: FileList): void;
}

enum TafFileDropZoneLocale {
  en = 'en',
  nl = 'nl',
}

class FileInput extends React.PureComponent<FileInputProps> {
  private readonly storage: AppStorage;

  constructor(props: FileInputProps) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  uploadFileHandler = (event: CustomEvent<FileList>): void => {
    const { fileUploadHandler } = this.props;
    if (event.detail && fileUploadHandler) {
      fileUploadHandler(event.detail);
    }
  };

  render(): React.ReactElement {
    const lang = this.storage.getLocale;
    const maxFileSize = isBrand(Brand.DHMR) ? '20' : '2';
    const maxTotalFileSize = '30';

    return (
      <TafFileDropZone
        id="tafFileDropZone"
        locale={lang.toLowerCase() as TafFileDropZoneLocale}
        onFileUploadHandler={this.uploadFileHandler}
        maxFileSize={maxFileSize}
        maxTotalFileSize={maxTotalFileSize}
      />
    );
  }
}

export default observer(FileInput);
